import React, { useEffect, useState } from 'react'
import styles from './styles.module.scss'
import { formatLastUpdateDate } from 'srcReact/helpers/datetimeHelper'
import { getDescryptedMedia } from 'srcReact/helpers/utils'
import { useTranslation } from 'react-i18next'
import { isEmpty } from 'lodash'

function Notification({ notification, divider, markAsRead, isLastNotification, lastNotificationRef }) {
  const { id_notification, is_read, icon, date_utc, content, is_original, original_tag, mime_type } = notification
  const [decryptedImage, setDecryptedImage] = useState('')
  const { t } = useTranslation()
  useEffect(() => {
    if (icon) {
      getDescryptedMedia(icon, is_original, original_tag, mime_type).then((data) => setDecryptedImage(data))
    }
  }, [icon])
  return (
    <React.Fragment key={id_notification}>
      <div className={styles.notificationWrapper}>
        {is_read === 0 && <div className={styles.unread}></div>}
        <button
          type='button'
          onClick={() => markAsRead(notification)}
          className={`${styles.notificationLink} ${is_read == 1 && styles.isRead}`}
          key={id_notification}
          ref={isLastNotification ? lastNotificationRef : null}>
          <img src={decryptedImage} className={styles.image} alt='' />
          <div className={styles.content}>
            <span className={styles.time}>{formatLastUpdateDate(date_utc, '', t)}</span>
            <div className={styles.title}>{content}</div>
          </div>
        </button>
      </div>
    </React.Fragment>
  )
}

export default Notification
